import columns from "./columns";
import searchFields from "./searchFields";
import formFields from "./formFields";
import previewFields from "./previewFields";

export default {
    entityName: "adminUsers",
    pageTitle: "Admins",
    displayName: "admins",
    columns,
    searchFields,
    searchPlaceholder: "e.g. email:example@example.com",
    formFields,
    previewFields,
};
